/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import Handsontable from 'handsontable';

export const DAYSOFF = [];

export function readOnlyRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.style.color = '#000';
  td.style.background = '#EEE';
  return td;
}

export function middleCellRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (value) {
    td.style.borderWidth = '1px 0 1px 0';
    td.style.borderStyle = 'solid';
    td.style.borderColor = 'rgb(134, 132, 132)';
    td.style.backgroundColor = 'rgba(3, 169, 244, 0.69)';
    td.style.color = 'white';
  } else {
    td.style.color = '#000';
    td.style.backgroundColor = DAYSOFF.indexOf(col) >= 0 ? '#F9FFA3' : 'white';
    td.style.borderLeftColor = 'rgb(134, 132, 132)';
    td.style.borderRightColor = 'rgb(134, 132, 132)';
  }

  return td;
}

export function leftCellRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (value) {
    td.style.borderWidth = '1px 0 1px 1px';
    td.style.borderStyle = 'solid';
    td.style.borderColor = 'rgb(134, 132, 132)';
    td.style.backgroundColor = 'rgba(3, 169, 244, 0.69)';
    td.style.color = 'white';
  } else {
    td.style.color = '#000';
    td.style.backgroundColor = DAYSOFF.indexOf(col) >= 0 ? '#F9FFA3' : 'white';
    td.style.borderRightColor = 'rgb(134, 132, 132)';
  }
  return td;
}

export function rightCellRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (value) {
    td.style.borderWidth = '1px 1px 1px 0';
    td.style.borderStyle = 'solid';
    td.style.borderColor = 'rgb(134, 132, 132)';
    td.style.backgroundColor = 'rgba(3, 169, 244, 0.69)';
    td.style.color = 'white';
  } else {
    td.style.color = '#000';
    td.style.backgroundColor = DAYSOFF.indexOf(col) >= 0 ? '#F9FFA3' : 'white';
    td.style.borderLeftColor = 'rgb(134, 132, 132)';
  }
  return td;
}

export function singleCellRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (value) {
    td.style.borderWidth = '1px';
    td.style.borderStyle = 'solid';
    td.style.borderColor = 'rgb(134, 132, 132)';
    td.style.backgroundColor = 'rgba(3, 169, 244, 0.69)';
    td.style.color = 'white';
  } else {
    td.style.backgroundColor = DAYSOFF.indexOf(col) >= 0 ? '#F9FFA3' : 'white';
    td.style.color = '#000';
  }
  return td;
}

export function dayOffRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.style.backgroundColor = '#F9FFA3';
  td.style.color = 'black';
  return td;
}

export function importedCellRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.style.backgroundColor = DAYSOFF.indexOf(col) >= 0 ? '#F9FFA3' : 'white';
  td.style.fontStyle = 'italic';
  return td;
}

export function absenceValidator(val, callback) {
  val = val.replace(',', '.');
  callback((val >= 0.03 && val <= 1 && val.length < 8) || val === '' || val === 0);
}

export const columns = [
  {
    data: 'contractId',
    type: 'numeric',
    width: 40,
    readOnly: true,
    renderer: readOnlyRenderer
  },
  {
    data: 'lastName',
    type: 'text',
    readOnly: true,
    renderer: readOnlyRenderer
  },
  {
    data: 'firstName',
    type: 'text',
    readOnly: true,
    renderer: readOnlyRenderer
  },
  {
    data: 'contractName',
    type: 'text',
    readOnly: true,
    renderer: readOnlyRenderer
  }
];

export const colHeaders = [
  'id',
  'last_name',
  'first_name',
  'Contract'
];
